import $ from 'jquery';

import 'popper.js';
import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

window.app = window.app || {};
window.app.modules =  window.app.modules || {};

let app = window.app;



import initModulesInScope from "@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};

import './scripts/common';

import * as recaptcha from './scripts/recaptcha';
app.modules.recaptcha = recaptcha.initInScope;
/**********************************
 *
 *      Site Stuff
 *
 * ********************************/


import * as shariff from './scripts/shariff';
app.modules.shariff = shariff.initInScope;

import * as videoJs from './scripts/videoJs';
app.modules.videoJs = videoJs.initInScope;

import * as displayDependent from './scripts/display-dependent';
app.modules.displayDependent = displayDependent.initInScope;

import * as lightbox from '@elements/lightbox';
app.modules.lightbox = lightbox.initInScope;

import * as swiper from './scripts/swiper';

app.modules.productContentTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-product-content-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        centerInsufficientSlides: true,
        loop: false,
        slidesPerView: 2,
        spaceBetween: 20,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 4,
                spaceBetween: 40
            }
        }
    });

app.modules.contentTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-content-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 40,
                allowTouchMove:false
            }
        }
    });


import * as imageThumbSwiper from './scripts/image-thumb-swiper';
app.modules.imageThumbSwiper = imageThumbSwiper.initInScope;


app.modules.contentTeaserSwiperBig = swiper.createInitInScope({
        sliderContainer: '.js-swiper-content-teaser-big',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 1,
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        }
    });

app.modules.teaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        scrollbar: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__scrollbar'),
            draggable: true,
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        }
    });


app.modules.articleTeaserSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-article-teaser',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 40,
                allowTouchMove:false
            }
        }
    });

app.modules.brandsSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-brands',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 2.4,
        spaceBetween: 20,
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 6,
                spaceBetween: 20,
                allowTouchMove:false
            }
        }
    });

app.modules.topBrandsSwiper = swiper.createInitInScope({
        sliderContainer: '.js-swiper-top-brands',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        slidesPerView: 1.2,
        spaceBetween: 20,
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        breakpoints: {
            // when window width is >= 768px
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
                allowTouchMove:false,
            }
        }
    });

import * as smoothScroll from '@elements/smooth-scroll';
let options = {
    offset: 120
};

smoothScroll.init(options, {});
smoothScroll.initInScope();

import * as imgTextSwiper from './scripts/img-text-swiper';
app.modules.imgTextSwiper = imgTextSwiper.createInitInScope({
        sliderContainer: '.js-swiper-img-text',
        slider: '.js-swiper__slider',
        sliderScrollbar: '.js-swiper__scrollbar',
        sliderPrev: '.js-swiper__prev',
        sliderNex: '.js-swiper__next'
    },
    {
        loop: false,
        allowTouchMove:false,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction:false
        },
        navigation: {
            findNextElement: $swiperContainer => $swiperContainer.find('.js-swiper__next'),
            findPrevElement: $swiperContainer => $swiperContainer.find('.js-swiper__prev'),
        },
        pagination: {
            findElement: $swiperContainer => $swiperContainer.find('.js-swiper__pagination'),
            clickable: true
        },
    });

import * as floatingLabel from '@elements/floating-labels';
app.modules.floatingLabel = floatingLabel.initInScope;

import * as anchorNav from '@elements/anchor-nav';
app.anchorNav  = anchorNav.createInitInScope({
    list: '.js-anchor-nav',
    listItem: '.js-anchor-nav__item'
},  {
    renderItem: function (text, anchor) {
        return '<li class="nav-item anchor-nav__item"><a class="anchor-nav__link nav-link js-smoothscroll__link" href="#' + anchor + '"><span class="anchor-nav__title">' + text + '</span></a></li>';
    },
    smoothScroll: true,
    scrollSpy: true,
    scrollSpyOffset: 300
});

import * as parsley from '@elements/parsley-bootstrap-validation';
app.modules.parsley = parsley.initInScope;

import * as scrollingTabs from './scripts/scrolling-tabs';
app.modules.scrollingTabs = scrollingTabs.initInScope;

import * as fetchTabs from './scripts/fetch-tabs';
app.modules.fetchTabs = fetchTabs.initInScope;

import * as ajaxForm from '@elements/ajax-form';
app.modules.ajaxForm = ajaxForm.initInScope;

import * as dateInput from '@elements/date-input';
app.modules.dateInput = dateInput.initInScope;


import * as datepicker from '@elements/datepicker';
app.modules.datepicker = datepicker.initInScope;
app.modules.datepickerChangeYear = datepicker.createInitInScope({
    base: '.js-datepicker-change-year',
    input: '.js-datepicker-change-year__input',
    altField: '.js-datepicker-change-year__alt-field'
}, {
    changeYear: true,
    yearRange: "-100:+0",
    changeMonth: true,
});

import * as datepickerRange from '@elements/datepicker-range';
app.modules.datepickerRange = datepickerRange.initInScope;

import * as productGrid from '@elements/product-grid';
app.productGrid = productGrid.init;
app.modules.productGrid = productGrid.initInScope;

import * as productGridQuickFilter from '@elements/product-grid/quick-filter';
app.modules.productGridQuickFilter = productGridQuickFilter.initInScope;

import * as rangeSlider from './scripts/range-slider';
app.modules.rangeSlider = rangeSlider.initInScope;

import * as fileInput from '@elements/file-input';
app.modules.fileInput = fileInput.initInScope;

import * as showMore from './scripts/show-more';
app.modules.showMore = showMore.initInScope;

(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        // console.log('key',_key)
        // console.log('val',_val)
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})($);